<div class="container mt-2 pb-4">
  <div class="row">
    <div class="video-container" #videoContainer>
      <video id="video-player" class="video-player video-js vjs-default-skin" controls playsinline webkit-playsinline
        poster="../../../../assets/images/video_banner_keno.jpg" (click)="onVideoClick()">
        <source [src]="rouletteVideoUrl" *ngIf="rouletteVideoUrl && !rouletteVideoUrl.includes('.m3u8')" />
        <source [src]="rouletteVideoUrl" *ngIf="rouletteVideoUrl?.includes('.m3u8')" type="application/x-mpegURL" />
      </video>
    </div>
  </div>

  <div class="row">
    <div class="betting-container-header">

      <!-- <div class="header"> -->
        <div class="event-box">
          <div class="currentEventName">{{CurrentEventName}}</div>
          <div class="event-right">
             <button 
              class="btn-result" 
              type="button"
              data-toggle="modal" 
              data-target="#raceresultModal"
            >
              <i class="bi bi-card-text"></i>
              {{'COMMON.RESULTS' | translate}}
            </button>
          </div>
        </div>
        <div class="event-box">
          <div class="event-left">Next Draw : <span class="timer">{{NextDrowEventCode}}</span></div>
          <div class="event-right"> <i class="bi bi-clock"></i><span class="timer">{{ timerDisplay }}</span></div>
        </div>
      <!-- </div> -->
      <div class="gradient-line"></div>
    </div>
  </div>

  <div class="row">
    <div class="betting-container"> 

      <div class="headersection">
        <!-- Header Controls -->
        <!-- <div class="header-controls"> -->
          <!-- Quick Pick -->
          <!-- <div class="quick-pick">
            <span class="quick-pick-label">Quick Pick</span>
            <select [(ngModel)]="quickPickCount" class="quick-pick-select" (ngModelChange)="quickPick()">
              <option *ngFor="let n of [1,2,3,4,5,6,7,8,9,10]" [value]="n">{{n}}</option>
            </select> -->
            <!-- <button (click)="quickPick()" class="quick-pick-btn">⚡</button> -->
          <!-- </div> 

          <div class="button-container"> -->
            <!-- <div class="draws-container">
              <label class="draws-label">DRAWS</label>
              <div class="draws-control">
                <button class="btn" (click)="decrementDraws()"><span style="font-size: 14px;">−</span></button>
                <input type="text" [(ngModel)]="drawsCount" readonly />
                <button class="btn" (click)="incrementDraws()"><span style="font-size: 14px;">+</span></button>
              </div>
            </div> -->

            <!-- <button
              *ngIf="selectedBets.size > 0"
              (click)="addToBetSlip()"
              class="addtobetslip-btn"
            >
              <span>ADD TO BETSLIP</span>
            </button>
          </div> -->

          <!-- Clear Button -->
          <!-- <button (click)="clearSelection()" class="clear-btn">
          <span>CLEAR
            <img alt="delete-icon" src="../../../../../assets/images/delete.png" />
          </span>
        </button> -->
        <!-- </div> -->

        <!-- Betting Options -->
        <div class="betting-options">
          <div 
            *ngFor="let option of bettingOptions" 
            class="betting-option" 
            [class.option-selected]="option.selected"
            [style.background]="option.color" 
            (click)="toggleBettingOption(option)"
            [attr.data-api-id]="option.apiId"
            [attr.data-event-id]="option.eventId">
            <div class="option-label">
              {{ option.label }}
              <span *ngIf="option.selected" class="check-mark">✓</span>
            </div>
            <!-- <div class="option-odds">
              <span>{{ option.odds }}</span>
            </div> -->
          </div>
        </div>
      </div>


      <!-- Payout Multiplier Info -->
      <!-- <div *ngIf="getSelectedBettingOptions().length > 0" class="multiplier-info">
        <strong>Payout Multiplier: {{getTotalMultiplier().toFixed(2)}}x</strong>
        <span class="info-text">
          ({{getSelectedBettingOptionsText()}})
        </span>
      </div> -->

      <!-- Number Grid -->
      <div class="number-bg">
        <div class="number-grid">
          <div *ngFor="let row of numberRows" class="number-row">
            <button 
              *ngFor="let numObj of row" 
              (click)="toggleNumber(numObj)" 
              [class.selected]="isNumberSelected(numObj)"
              class="number-btn" 
              [ngClass]="{'trail-button': numObj.number > 40 && numObj.number <= 80}"
              [attr.data-id]="numObj.id"
              [attr.data-event-id]="numObj.eventId">
              {{ numObj.name }}
            </button>
          </div>
        </div>
      </div>

      <div style="display:flex; justify-content:center; margin-top:10px;">
        <button class="btn-clear" (click)="clearSelection()">
          Delete
          <i class="bi bi-trash"></i> 
        </button>
      </div>

      <!-- Selected Numbers Display -->
      <!-- <div *ngIf="selectedNumbers.length > 0" class="selected-display">
        <strong>Selected Numbers ({{selectedNumbers.length}}):</strong>
        <div class="selected-numbers">
          {{getSelectedNumbersSorted().join(', ')}}
        </div>
      </div> -->
    </div>
  </div>

  <!-- Result Modal -->
  <div class="modal fade" id="raceresultModal" data-backdrop="false" tabindex="100000" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" style="margin-left: 0px;margin-right: 0px;">
      <div class="modal-content" style="margin-top: 200px;margin-bottom: 100px;">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{'COMMON.RESULTS' | translate}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span style="font-size: 35px;" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <button class="price-table-btn" (click)="openPriceTable()">
            View Price Table
          </button>

          <div class="price-table-overlay" *ngIf="showPriceTable">
            <div class="price-table-modal">
              
              <button class="close-btn" (click)="closePriceTable()">✕</button>
          
              <app-image-zoom-viewer
                src="assets/images/keno_Prize_Table.jpg"
                alt="Price Table"
                [maxZoom]="4"
                [zoomStep]="0.5"
              ></app-image-zoom-viewer>

            </div>
          </div>
          

          <div *ngFor="let item of kironResults" class="race-preview shadow p-0 mb-2">
            <div class="race-header bg-fill-secondary text-white">
              <div class="race-info">
                <div class="race-name text-uppercase">{{item.eventName}}</div>
                <div class="race-description text-uppercase">Game: {{item.eventCode}}</div>
              </div>
              <div class="race-extra">
                {{item.eventTimeUTC.substr(11,5)}}
                <span class="secondary">{{item.eventTimeUTC.substr(0,10)}}</span>
              </div>
            </div>

            <div class="race-content">
              <div *ngFor="let position of item?.eventPositions">
                <span 
                  [ngClass]="{'keno-yellow-button': checkBallColor(position) == 'yellow', 'keno-red-button': checkBallColor(position) == 'red'}" 
                  class="numberCircle" 
                  style="display: inline-block;"
                >
                  {{position.selectionNumber}}
                </span>
              </div>

              <div class="result-box">
                <div class="result-row">
                  <span class="label">Heads/Evens/Tails</span>
                  <span class="value">{{item.kknWinnerHeadsEvensTails}}</span>
                </div>

                <div class="result-row">
                  <span class="label">Off Time</span>
                  <span class="value">{{item.offTime}}</span>
                </div>
              </div>
            </div>

          </div>

        </div>


        

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

</div>